import { Injectable } from '@angular/core';
import { MessageBusService } from '@xdig/ng-microkernel/micro-frontend';

@Injectable()
export class ModalService {
  constructor(private messageBusService: MessageBusService) {}

  close() {
    this.messageBusService.emit('shell', 'modal.error', { component: '', payload: null });
  }
}
